module.exports = __webpack_public_path__ + "static/media/zett.0602ac0a.png";